import { Component, effect, inject, input, signal } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { IIo } from '../../../../models/io';
import { Functions } from '../../../../services/shared/functions';
import { IconsStyles } from '../../../../services/shared/icons-styles';

@Component({
  selector: 'app-d-inputs-table',
  imports: [TableModule, PanelModule],
  templateUrl: './d-inputs-table.html',
  styleUrl: './d-inputs-table.css',
})
export class DInputsTable {
  ioInformation = input.required<IIo>();
  isLoading = input.required<boolean>();
  readonly iconsStyles = inject(IconsStyles);
  readonly customFunctions = inject(Functions);
  readonly shouldBeCollapsed = this.customFunctions.shouldBeCollapsed();

  tableRows = signal<string[]>([]);
  inputValues = signal<boolean[]>([]);
  tableRowsSmall = signal<{ value: boolean }[]>([]);

  constructor() {
    this.tableRows.update(() => {
      return ['status'];
    });
    effect(() => {
      const io = this.ioInformation();

      if (!io) {
        return;
      }
      this.inputValues.set([]);
      this.tableRowsSmall.set([]);

      for (let i = 0; i < io.amountOfInputs; i++) {
        let inputValue = this.customFunctions.bitwiseIO(
          io.digitalInputs,
          i + 1
        );

        this.inputValues.update((values) => {
          return [...values, inputValue];
        });

        this.tableRowsSmall.update((values) => {
          return [
            ...values,
            {
              value: inputValue,
            },
          ];
        });
      }
    });
  }
}
